import { parse as parsePostcss } from "postcss";
import { parse } from "css";
import { Call } from "@mui/icons-material";
import moment from "moment";

export const checkEmpty = (obj: any): boolean => {
  let status = false;
  for (const item in obj) {
    if (Array.isArray(obj[item])) {
      if (obj[item].length === 0 && item !== "locations") status = true;
    } else if (
      obj[item] === "<p></p>" ||
      obj[item] === null ||
      obj[item] === "" ||
      obj[item] === undefined ||
      obj[item] === "+"
    ) {
      status = true;
    }
  }

  return status;
};

export const detectURLs = (message: string) => {
  var urlRegex = /(((https?:\/\/)|(www\.))[^\s'">]+)/g;
  return message.match(urlRegex) || [];
};

export const removeAnchorTags = (str: string) => {
  const anchorRegex =
    /<a(?:\s+(?:[^>]*href=(["'])(.*?)\1|\S+))?[^>]*>(.*?)<\/a>/gi;
  const outputString = str.replace(
    anchorRegex,
    function (match, quote, url, name) {
      return name || url;
    }
  );

  return outputString;
};

export const fixAnchorTags = (htmlContent: any) => {
  const regex =
    /<a\s+(?![^>]*\btarget\s*=\s*["'][^"']*["'])(?:[^>]*\s+)?href=(["'])(.*?)\1[^>]*>(.*?)<\/a>/gi;
  const fixedHtmlContent = htmlContent.replace(
    regex,
    (match: any, quote: any, url: any, name: any) => {
      if (!url.startsWith("http://") && !url.startsWith("https://")) {
        url = "http://" + url;
      }
      return `<a href="${url}" target="_blank">${name}</a>`;
    }
  );
  return fixedHtmlContent;
};

export const parseStyles = (cssString) => {
  const parsed = parse(cssString);
  // Convert the parsed data to a format that can be used with the style attribute
  // For example:
  const styles = {};
  parsed.stylesheet.rules.forEach((rule: any) => {
    if (rule.type === "rule") {
      rule.declarations.forEach((declaration) => {
        styles[declaration.property] = declaration.value;
      });
    }
  });
  return styles;
};

export const parsePostcssStyles = (cssString: any) => {
  const parsed = parsePostcss(cssString);
  return parsed;
};

function convertCssStringToObject(cssString) {
  const stylesObject = {};

  const declarations = cssString.split(";");
  for (const declaration of declarations) {
    const [property, value] = declaration.split(":");
    if (property && value) {
      const camelCaseProperty = property
        .trim()
        .replace(/-./g, (match) => match.charAt(1).toUpperCase());
      stylesObject[camelCaseProperty] = value.trim();
    }
  }

  return stylesObject;
}

export const parseStringStyles = (cssString: string) => {
  const styles = {};
  const cleanedString = cssString.replace(/[\n\r\s{}]+/g, "");
  const declarations = cleanedString.split(";");

  declarations.forEach((declaration) => {
    const [property, value] = declaration.split(":");
    if (property && value) {
      styles[property.trim()] = value.trim();
    }
  });

  return styles;
};

/**
 * Authorizes user access to a feature based on user type.
 * If the user type is FREE_USER, the provided callback is executed.
 * Otherwise, the provided function to open the upgrade modal is called.
 * @param userType The type of the user.
 * @param openUpgradeModal Function to open the upgrade modal.
 * @param callback Callback function to execute if user type is not FREE_USER.
 */

const isWithinFreeTrial = (userData: any): boolean => {
  if (!userData || !userData.freeTrialStartDate) {
    return false;
  }

  const startDateOfFreeTrial = moment(userData.freeTrialStartDate);
  const endDateOf7DayPeriod = startDateOfFreeTrial.clone().add(7, "days");
  const daysLeftInTrial = endDateOf7DayPeriod.diff(moment(), "days");

  return daysLeftInTrial > 0;
};

export const authorizeFeatureAccess = (
  userData: any,
  openUpgradeModal: () => void,
  callback: () => void
): void => {
  if (userData?.userType !== "FREE_USER" || isWithinFreeTrial(userData)) {
    callback();
  } else {
    openUpgradeModal();
  }
};

export const isAuthorizedUser = (userData: any): boolean => {
  if (userData?.userType !== "FREE_USER" || isWithinFreeTrial(userData))
    return true;
  else return false;
};
